import React from 'react';
import './style.css';

import CommonCell from '@elements/ContainerRowItem/CommonCell';
import { getClasses } from '@utils';

type CommonRowProps = {
  id?: string;
  className?: string;
  ridx: number;
  cells: Array<{
    cid: string;
  }>;
};

const CommonRow = ({ cells, ridx, className, id }: CommonRowProps): JSX.Element => (
  <div className={getClasses("common-container-row", className)} id={id || `container-row-item-${ridx}`}>
    <ul className={getClasses(className && `${className}-row${ridx}`)}>
      {cells.map((oneCell, cidx) => (
        <CommonCell
          key={oneCell.cid}
          cell={oneCell}
          cidx={cidx}
          className={className && `${className}-cell`}
          subClassName={className && `${className}-subcell`}
        />
      ))}
    </ul>
  </div>
);

export default CommonRow;
